import { z } from 'zod';

/**
 * `agent:stream_stalled`: a native model stream went silent for the stall guard's whole
 * window (packages/agent-sdk engine/stream-stall-guard.ts; streamed tool input counts as
 * progress, an SSE ping does not). Sent once per stall from the round catch, whether the
 * engine re-issued the round (`reissued`) or the turn ended on it. Each leaves a durable
 * `error_events` row (category `stream_stalled`). SERVER-CONSUMED, never forwarded.
 * Carries no conversation text.
 */
export const AgentStreamStalledPayloadSchema = z.object({
  taskId: z.string(),
  sessionId: z.string(),
  /** The engine re-issued the round; false when the turn ends on this stall. */
  reissued: z.boolean(),
  /** The turn's re-issues so far (this one included when `reissued`). */
  reissues: z.number(),
  /** The idle window that ran out, in ms. */
  idleMs: z.number(),
  /** Stream events the round yielded before it went silent. */
  eventsSeen: z.number(),
  /** The kind of the last event before the silence; null when it stalled before the first. */
  lastEventKind: z.string().nullable(),
  /** The transport's wire dialect (`anthropic_messages`, `openai_responses`, …). */
  api: z.string(),
  model: z.string(),
  /** The tool call the stall cut mid-input, and its input size so far; null when none. */
  cutTool: z.string().nullable(),
  cutBytes: z.number().nullable(),
});
